import { CommonModule } from '@angular/common';
import { Component, computed, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize, of } from 'rxjs';
import { CaseManagementService } from '../../../../../../../../services/case-management.service';
import { CaseArchiveModel } from '@models/case-archive.model';
import { AuthSrcDirective } from '../../../../../../../directives/auth-src.directive';
import { PreloaderColor, UiPreloaderComponent } from '@ui';

@Component({
  selector: 'app-case-manager-objects-preview',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    AuthSrcDirective,
    UiPreloaderComponent,
  ],
  templateUrl: './case-manager-objects-preview.component.html',
  styleUrls: ['../case-manager-feature-preview.shared.scss'],
})
export class CaseManagerObjectsPreviewComponent implements OnInit {
  private readonly caseManagementService = inject(CaseManagementService);
  private readonly destroyRef = inject(DestroyRef);

  readonly caseId = input.required<string>();

  protected readonly preloaderColor = PreloaderColor.blue;
  protected readonly objectGroups = signal<CaseArchiveModel.CaseObjectsByArchive[]>([]);
  protected readonly isLoading = signal(false);
  protected readonly objectCards = computed(() => this.objectGroups().flatMap((group) =>
    group.objectUrls.map((objectUrl, index) => ({
      key: `${group.sessionId}:${objectUrl}:${index}`,
      objectUrl,
      archiveName: group.name,
    })),
  ));

  public ngOnInit(): void {
    this.loadObjects();
  }

  private loadObjects(): void {
    this.isLoading.set(true);
    this.caseManagementService.getCaseObjectUrls(this.caseId())
      .pipe(
        catchError(() => of([])),
        finalize(() => this.isLoading.set(false)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((groups) => this.objectGroups.set(groups));
  }
}
